import { AppState } from "../../index";

export const getPaymentState = (state: AppState) => state.payment;
